import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Switch } from "../ui/switch";
import { useAuthedApi, errMsg } from "../../lib/api";

const LABELS = { seller_type: "Seller type (Owner / Dealer)", brand: "Brand", price: "Min / Max price", fuel: "Fuel", transmission: "Gearbox", body_type: "Body type", min_year: "Year from", max_km: "Max KM driven", max_owners: "Max owners", color: "Colour" };

export default function AdminFilters() {
  const api = useAuthedApi();
  const [s, setS] = useState(null);
  useEffect(() => { api("get", "/settings/filters").then(setS); }, [api]);
  const toggle = async (k, v) => {
    const next = { ...s, [k]: v };
    setS(next);
    try { await api("put", "/admin/settings/filters", next); toast.success(`${LABELS[k]} filter ${v ? "shown" : "hidden"}`); }
    catch (e) { setS(s); toast.error(errMsg(e)); }
  };
  if (!s) return <p className="text-gray-500">Loading...</p>;
  return (
    <div className="lux-card p-5 max-w-2xl" data-testid="admin-filters">
      <p className="eyebrow mb-1">Browse page filters</p>
      <p className="text-sm text-gray-400 mb-4">Choose which filters buyers see on the Browse Cars page.</p>
      <div className="grid sm:grid-cols-2 gap-2">
        {Object.keys(LABELS).map((k) => (
          <label key={k} className="flex items-center justify-between gap-3 rounded-xl border border-white/5 px-3 py-2.5 cursor-pointer hover:border-[#D4AF37]/40">
            <span className="text-sm">{LABELS[k]}</span>
            <Switch className="data-[state=unchecked]:bg-gray-600" checked={s[k] !== false} onCheckedChange={(v) => toggle(k, v)} data-testid={`admin-filter-${k}`} />
          </label>
        ))}
      </div>
    </div>
  );
}
